(function () {
  const initStickyCta = () => {
    const roots = document.querySelectorAll('[data-sticky-cta]');
    if (!roots.length) return;

    if (roots.length > 1) {
      for (let i = 1; i < roots.length; i += 1) {
        roots[i].remove();
      }
    }

    const root = roots[0];
    if (!root) return;

    const panel = root.querySelector('[data-sticky-cta-panel]');
    if (!panel) return;

    const dismissButton = root.querySelector('[data-sticky-cta-dismiss]');
    const toggleButton = root.querySelector('[data-sticky-cta-toggle]');
    const toggleIcon = root.querySelector('[data-sticky-cta-toggle-icon]');
    const details = root.querySelector('[data-sticky-cta-details]');

    let showAfter = parseInt(root.getAttribute('data-show-after') || '280', 10);
    const hideOnScrollDown = root.getAttribute('data-hide-on-scroll-down') === '1';
    const dismissible = root.getAttribute('data-dismissible') === '1';
    const rememberDismissal = root.getAttribute('data-remember-dismissal') === '1';
    const storageKey = root.getAttribute('data-storage-key') || 'maweoStickyCtaDismissed';
    const density = root.getAttribute('data-density') || 'compact';

    showAfter = Number.isNaN(showAfter) ? 280 : Math.max(0, showAfter);

    let dismissed = false;
    let hiddenByDirection = false;
    let expanded = false;
    let lastY = window.scrollY || window.pageYOffset || 0;
    let ticking = false;

    const setBackToTopOffset = (visible) => {
      const isMobile = window.matchMedia('(max-width: 1023px)').matches;
      if (!isMobile || !visible) {
        document.documentElement.style.setProperty('--maweo-sticky-cta-offset', '0px');
        return;
      }

      if (density === 'compact' && !expanded) {
        document.documentElement.style.setProperty('--maweo-sticky-cta-offset', '0px');
        return;
      }

      const panelHeight = panel.getBoundingClientRect().height || 0;
      document.documentElement.style.setProperty('--maweo-sticky-cta-offset', `${Math.ceil(panelHeight + 12)}px`);
    };

    const setVisible = (visible) => {
      panel.classList.toggle('opacity-0', !visible);
      panel.classList.toggle('translate-y-5', !visible);
      panel.classList.toggle('opacity-100', visible);
      panel.classList.toggle('translate-y-0', visible);
      panel.classList.toggle('pointer-events-none', !visible);
      panel.classList.toggle('pointer-events-auto', visible);
      panel.style.visibility = visible ? 'visible' : 'hidden';
      window.requestAnimationFrame(() => {
        setBackToTopOffset(visible);
      });
    };

    const syncCompactDetails = () => {
      if (!details || density !== 'compact') return;
      const isMobile = window.matchMedia('(max-width: 1023px)').matches;
      root.classList.toggle('is-expanded', isMobile && expanded);
      details.hidden = !expanded;
      if (toggleButton) toggleButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (toggleIcon) toggleIcon.classList.toggle('rotate-180', expanded);
    };

    if (dismissible && rememberDismissal) {
      try {
        if (window.sessionStorage.getItem(storageKey) === '1') {
          dismissed = true;
        }
      } catch (_error) {
        // ignore session storage access errors
      }
    }

    if (dismissed) {
      document.documentElement.style.setProperty('--maweo-sticky-cta-offset', '0px');
      root.remove();
      return;
    }

    const update = () => {
      const y = window.scrollY || window.pageYOffset || 0;
      const passedThreshold = y >= showAfter;

      if (hideOnScrollDown && passedThreshold) {
        if (y > lastY + 4) {
          hiddenByDirection = true;
        } else if (y < lastY - 4) {
          hiddenByDirection = false;
        }
      } else {
        hiddenByDirection = false;
      }

      setVisible(passedThreshold && !dismissed && !hiddenByDirection);
      lastY = y;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    };

    if (dismissButton) {
      dismissButton.addEventListener('click', () => {
        dismissed = true;
        setVisible(false);
        document.documentElement.style.setProperty('--maweo-sticky-cta-offset', '0px');
        if (rememberDismissal) {
          try {
            window.sessionStorage.setItem(storageKey, '1');
          } catch (_error) {
            // ignore session storage access errors
          }
        }
      });
    }

    if (toggleButton && details && density === 'compact') {
      toggleButton.addEventListener('click', () => {
        expanded = !expanded;
        syncCompactDetails();
        window.requestAnimationFrame(() => {
          setBackToTopOffset(!panel.classList.contains('opacity-0'));
        });
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      syncCompactDetails();
      onScroll();
    });

    syncCompactDetails();
    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCta);
  } else {
    initStickyCta();
  }
})();
